import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`  
  body {
    background-color: #000;
    /* background-color: transparent; */
    background-size: 5px 5px, 5px 5px;
    background-position: -1px -1px, -1px -1px;
    background-image: linear-gradient(rgba(205, 7, 255, 0.157) 1px, transparent 1px),
      linear-gradient(90deg, rgba(41, 240, 247, 0.1449) 1px, transparent 1px);
    mix-blend-mode: difference;

    text-rendering: optimizeSpeed;
    font-family: 'Montserrat', sans-serif;
    
    a {
      cursor: pointer;
    }
  }
  
  html {
    scroll-behavior: smooth;
  }

  /* Box sizing rules */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Remove default margin */
body,
h1,
h2,
h3,
h4,
p,
figure,
blockquote,
dl,
dd {
  margin: 0;
}

/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul[role='list'],
ol[role='list'] {
  list-style: none;
}

/* Set core root defaults */
html:focus-within {
  scroll-behavior: smooth;
}

/* Set core body defaults */
html, body, #root {
  height: 100%;
  /* TODO: undo this temporary solution to stop scrollbars */
  /* overflow: hidden; */
}

/* A elements that don't have a class get default styles */
a:not([class]) {
  text-decoration-skip-ink: auto;
}

/* Make images easier to work with */
img,
picture {
  max-width: 100%;
  display: block;
}

/* Inherit fonts for inputs and buttons */
input,
button,
textarea,
select {
  font: inherit;
}

`;

export default GlobalStyle;
